<script>
	import {
		faChevronDown,
		faChevronUp,
	} from "@fortawesome/free-solid-svg-icons";
	import SvelteFa from "$lib/components/SvelteFa.svelte";

	export let content;
	export let handleChange = () => {};

	export let expanded = false;
	export let hideAll = false;
	export let previewHeightClass = "max-h-36";
	export let previewLabelShow;
	export let previewLabelHide;

	const handleClick = () => {
		expanded = !expanded;
		handleChange();
	};

	$: closedClass = `${hideAll ? `max-h-0` : previewHeightClass} [mask-image:linear-gradient(to_bottom,_black,_black,_black,_transparent)]`;
</script>

<div
	class={`overflow-hidden transition-all duration-500 ${expanded ? "max-h-[500px]" : closedClass}`}
>
	<p>{@html content}</p>
</div>
<button
	on:click={handleClick}
	class="text-slate-500 mt-2 hover:cursor-pointer"
	aria-label="show more"
>
	{#if previewLabelShow && previewLabelHide}
		{expanded ? previewLabelHide : previewLabelShow}
	{:else if expanded}
		<SvelteFa icon={faChevronUp} />
	{:else}
		<SvelteFa icon={faChevronDown} />
	{/if}
</button>

<!-- <div class="max-h-40 overflow-hidden [mask-image:linear-gradient(to_bottom,_black,_transparent)]">
    <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.
    </p>
</div> -->
